/* ============================================================
   PSI v213 — Nascondi / Mostra filtri sulle pagine collezione
   ------------------------------------------------------------
   Inietta il pulsante dentro .collection-toolbar (subito prima di
   "Ordina per") e commuta la classe html.psi-ft-off, che e' l'unico
   interruttore: tutta la grafica sta in psi-filters-toggle.css.
   La scelta si ricorda in localStorage, cosi' passando da una
   collezione all'altra i filtri restano come li ha lasciati il
   cliente (come su Nike). Per evitare il lampo dei filtri al
   caricamento, la classe la mette gia' uno script inline nel <head>
   di layout/theme.liquid: qui la si legge, non la si reimposta.
   Nessun file del tema e' stato modificato per questa funzione,
   a parte le due righe di caricamento nel <head>.
   ============================================================ */
(function () {
  "use strict";

  var KEY = "psi-filtri-nascosti";
  var TESTO_NASCONDI = "Nascondi filtri";
  var TESTO_MOSTRA = "Mostra filtri";

  var ICONA =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<line x1="4" y1="7" x2="20" y2="7"/><circle cx="9" cy="7" r="2"/>' +
    '<line x1="4" y1="17" x2="20" y2="17"/><circle cx="15" cy="17" r="2"/>' +
    "</svg>";

  function nascosti() {
    return document.documentElement.classList.contains("psi-ft-off");
  }

  function init() {
    var page = document.querySelector(".collection-page");
    if (!page) return;

    var layout = page.querySelector(".collection-layout");
    var toolbar = page.querySelector(".collection-toolbar");
    var sidebar = page.querySelector(".psi-desktop-filter-sidebar");
    // Senza colonna filtri non c'e' niente da nascondere: nessun pulsante.
    if (!layout || !toolbar || !sidebar) return;
    if (toolbar.querySelector(".psi-ft-btn")) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "psi-ft-btn";
    btn.innerHTML = ICONA + '<span class="psi-ft-label"></span>';

    var sort = toolbar.querySelector(".collection-sort");
    if (sort) {
      toolbar.insertBefore(btn, sort);
    } else {
      toolbar.appendChild(btn);
    }

    function aggiorna() {
      var off = nascosti();
      btn.querySelector(".psi-ft-label").textContent = off
        ? TESTO_MOSTRA
        : TESTO_NASCONDI;
      btn.setAttribute("aria-pressed", off ? "true" : "false");
      btn.setAttribute("aria-expanded", off ? "false" : "true");
    }

    btn.addEventListener("click", function () {
      var off = !nascosti();
      document.documentElement.classList.toggle("psi-ft-off", off);
      try {
        localStorage.setItem(KEY, off ? "1" : "0");
      } catch (e) {}
      aggiorna();
    });

    aggiorna();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
